import '../../components/Calculator/Calculator';
import PriceTableSelect from './PriceTable/PriceTableSelect';
import PriceTable from './PriceTable/PriceTable';

// Get html for pricing page
const getHTML = (url) => new Promise((resolve, reject) => {
  if (!window.XMLHttpRequest) return;
  const xhr = new XMLHttpRequest();

  xhr.onload = () => {
    if (xhr.status >= 200 && xhr.status < 300) {
      resolve(xhr.response);
    } else {
      reject(xhr.statusText);
    }
  };

  xhr.open('GET', url);
  xhr.send();
});

const pricingContainer = document.querySelector('[data-pricing-table]');
if (pricingContainer) {
  const siteId = pricingContainer.getAttribute('data-pricing-table');
  getHTML(`/assets/get_pricing_block/?siteId=${siteId}&format=json`).then((response) => {
    const calcData = JSON.parse(response);
    PriceTable(calcData).then((table) => {
      PriceTableSelect({
        calcData,
        selectClassName: 'price-table-select',
      });
      pricingContainer.removeChild(pricingContainer.querySelector('.Loader'));
      pricingContainer.appendChild(table);
    });
  });
}
